import React, { type HTMLAttributes, useEffect, useState } from 'react';
import styled from 'styled-components';
import { rem } from 'modules/helpers/style';
import { colors, breakpoint, sizes } from 'variables';
import { ColorBrandBlue1 } from 'autogen/design-tokens/tokens';

const Container = styled.div`
    display: flex;
`;

const TimeGroup = styled.div`
    display: flex;
    font-size: ${rem(18)};

    &:after {
        content: ':';
        display: flex;
        align-items: center;
    }

    &:last-of-type {
        &:after {
            content: none;
        }
    }

    ${breakpoint.up(sizes.md)} {
        font-size: ${rem(24)};
    }

    ${breakpoint.up(sizes.xl)} {
        font-size: ${rem(36)};
    }
`;

const Box = styled.span`
    background-color: ${ColorBrandBlue1};
    color: ${colors.negative};
    font-weight: bold;
    margin: 4px;
    padding: 4px 6px;

    ${breakpoint.up(sizes.md)} {
        margin: 6px;
        padding: 6px 10px;
    }

    ${breakpoint.up(sizes.xl)} {
        margin: 8px;
        padding: 8px 14px;
    }
`;

type ICountdown = HTMLAttributes<HTMLDivElement> & {
    startTime: Date;
};

const SimpleCountdown = (props: ICountdown): JSX.Element => {
    const { startTime, ...restProps } = props;

    const pad = (num): string => {
        let s = `${num}`;
        while (s.length < 2) s = `0${s}`;
        return s;
    };

    const calculateTimeLeft = (): any => {
        const difference = +new Date(startTime) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                // days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: pad(Math.floor((difference / 1000 / 60) % 60)),
                seconds: pad(Math.floor((difference / 1000) % 60))
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState<any>(calculateTimeLeft());

    useEffect((): void => {
        setTimeout((): void => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
    });

    const timerComponents: JSX.Element[] = [];

    Object.keys(timeLeft).forEach((interval) => {
        if (!timeLeft[interval]) {
            return;
        }

        timerComponents.push(
            <TimeGroup key={interval}>
                <Box>{timeLeft[interval]}</Box>
            </TimeGroup>
        );
    });

    return (
        <Container {...restProps}>
            {timerComponents.length ? (
                timerComponents
            ) : (
                <>
                    <TimeGroup>
                        <Box>00</Box>
                    </TimeGroup>
                    <TimeGroup>
                        <Box>00</Box>
                    </TimeGroup>
                </>
            )}
        </Container>
    );
};

export default SimpleCountdown;
